import { Maybe } from 'maybe-not';
import { IDict } from '../types/utility';
import { sendMessage } from 'q2-tecton-common/lib/utility/message-bus';

export default function setParams(moduleId: string, platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('setParams')) {
        return;
    }

    return function(params: IDict<string>): void {
        const messageBody = {
            moduleId,
            params
        };
        sendMessage('setParams', Maybe.just(JSON.stringify(messageBody)));
    };
}
